import { all_routes } from "../../../router/backendComponents/admin/all_routes";
const routes = all_routes;

export const HorizontalSidebarData = [
  {
    title: "MAIN MENU",
    showAsTab: false,
    separateRoute: false,
    menu: [
      {
        menuValue: "Bussiness Summary",
        hasSubRoute: true,
        showSubRoute: false,
        icon: "ti ti-layout-2",
        base: "Bussiness Summary",
        subMenus: [
          {
            menuValue: "Expanses Report",
            route: routes.expences,
            base: "Expanses Report",
          },

          {
            menuValue: "Sale Report",
            customSubmenuTwo: true,
            hasSubRoute: true,
            showSubRoute: false,
            icon: "ti ti-user-star",
            base: "Sale Report",
            subMenusTwo: [
              {
                menuValue: "Finacial Records",
                route: routes.saleReport,
                base: "Finacial Records",
              },
              {
                menuValue: "Perfomance Report",
                route: routes.performanceReport,
                base: "Perfomance Report",
              },
            ],
          },
          {
            menuValue: "Order Summary",
            route: routes.orderSummary,
            base: "Order Summary",
          },
          {
            menuValue: "Quotation Summary",
            route: routes.quotationSummary,
            base: "Quotation Summary",
          },
        ],
      },

      {
        menuValue: "Sale Inside",
        hasSubRoute: true,
        showSubRoute: false,
        icon: "ti ti-layout-2",
        base: "Sale Inside",
        subMenus: [
          {
            menuValue: "Quotation",
            customSubmenuTwo: true,
            hasSubRoute: true,
            showSubRoute: false,
            icon: "ti ti-user-star",
            base: "Quotation",
            subMenusTwo: [
              {
                menuValue: "Quotation Details",
                route: routes.quotation,
                base: "Quotation Details",
              },
              {
                menuValue: "Quotation Report",
                route: routes.quotationReport,
                base: "Quotation Report",
              },
            ],
          },
          {
            menuValue: "Order",
            customSubmenuTwo: true,
            hasSubRoute: true,
            showSubRoute: false,
            icon: "ti ti-user-star",
            base: "dashboard",
            subMenusTwo: [
              {
                menuValue: "Full Order",
                route: routes.order,
                base: "Full Order",
              },
              {
                menuValue: "Partial Order",
                route: routes.partialOrder,
                base: "Partial Order",
              },
            ],
          },

          {
            menuValue: "Order Report",
            route: routes.orderReport,
            base: "Order Report",
          },
        ],
      },

      {
        menuValue: "Directory",
        hasSubRoute: true,
        showSubRoute: false,
        icon: "ti ti-layout-2",
        base: "Directory",
        subMenus: [
          {
            menuValue: "Owner",
            route: routes.owner,
            base: "Owners",
          },

          {
            menuValue: "Customers",
            route: routes.customer,
            base: "Customer",
          },
          {
            menuValue: "User",
            route: routes.user,
            base: "User",
          },

          {
            menuValue: "Role Access",
            route: routes.roleAcess,
            base: "Role Access",
          },
        ],
      },

      {
        menuValue: "Catalog",
        hasSubRoute: true,
        showSubRoute: false,
        icon: "ti ti-layout-2",
        base: "Catalog",
        subMenus: [
          {
            menuValue: "Product",
            route: routes.product,
            base: "Product",
          },

          {
            menuValue: "Parameters",
            route: routes.parameter,
            base: "Parameters",
          },
          {
            menuValue: "USPs",
            route: routes.usp,
            base: "USPs",
          },

          {
            menuValue: "Brand",
            route: routes.brand,
            base: "Brand",
          },
          {
            menuValue: "Categories",
            route: routes.category,
            base: "Categories",
          },
        ],
      },

      {
        menuValue: "Settings",
        hasSubRoute: true,
        showSubRoute: false,
        icon: "ti ti-layout-2",
        base: "Catalog",
        subMenus: [
          {
            menuValue: "Quotation Format",
            route: routes.quotationFormat,
            base: "Product",
          },

          {
            menuValue: "Principal",
            route: routes.principal,
            base: "Principal",
          },
          {
            menuValue: "Reason",
            route: routes.reason,
            base: "Reason",
          },

          {
            menuValue: "Notification",
            route: routes.notifications,
            base: "Notification",
          },
        ],
      },

      {
        menuValue: "Vendor Inside",
        hasSubRoute: true,
        showSubRoute: false,
        icon: "ti ti-layout-2",
        base: "Vendor Inside",
        subMenus: [
          {
            menuValue: "Source",
            route: routes.source,
            base: "Product",
          },

          {
            menuValue: "Supplier",
            route: routes.supplier,
            base: "Principal",
          },
          {
            menuValue: "Courier",
            route: routes.courier,
            base: "Reason",
          },
        ],
      },
    ],
  },
];
